import {useTranslation} from 'react-i18next';
import CalendarOutline from '../../../../assets/icons/CalendarOutline';
import ClockOutline from '../../../../assets/icons/ClockOutline';
import {TEticketEvent} from '../../../../redux/eTicket/eTicket.type';
import * as css from './EventDateTime.css';
import {getDateFormat, getHourMinutes} from '../../../../library/dates';

interface EventDateTimeProps {
    event: TEticketEvent;
}

function EventDateTime({event}: EventDateTimeProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.row data-cy="ticket-event-datetime">
            {event.date && (
                <css.col>
                    <css.colLabel>{t('date')}</css.colLabel>
                    <css.colValue>
                        <span>{getDateFormat(event.date, 'DD.MM.YYYY')}</span>
                        <css.iconWrap><CalendarOutline /></css.iconWrap>
                    </css.colValue>
                </css.col>
            )}
            {event.timeOpen && (
                <css.col>
                    <css.colLabel>{t('gatesOpen')}</css.colLabel>
                    <css.colValue>
                        <span>{getHourMinutes(event.timeOpen)}</span>
                        <css.iconWrap><ClockOutline /></css.iconWrap>
                    </css.colValue>
                </css.col>
            )}
            {event.timeStart && (
                <css.col>
                    <css.colLabel>{t('startsAt')}</css.colLabel>
                    <css.colValue>
                        <span>{getHourMinutes(event.timeStart)}</span>
                        <css.iconWrap><ClockOutline /></css.iconWrap>
                    </css.colValue>
                </css.col>
            )}
        </css.row>
    );
}

export default EventDateTime;
